import Vue from 'vue'
import common from "@/units/common.js";
import Router from 'vue-router'
import axios from 'axios'

import Author from '@/pages/categry/Author'
import Ranking from '@/pages/categry/Ranking'

import ErrorPage from '@/common/error'
import AuthLogin from '@/pages/account/AuthLogin'

import { Form } from 'element-ui'
import store from '../store/index'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/Auth', name: 'Auth', component: () => import('@/pages/Auth') },
    { path: '/', name: 'Home', component: () => import('@/pages/Home/Home') },
    {
      path: '/AuthLogin',
      name: 'AuthLogin',
      component: AuthLogin
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorPage,
    },

    {
      path: '/Author',
      name: 'Author',
      component: Author,
    },
    {
      path: '/Ranking',
      name: 'Ranking',
      component: Ranking,
    },
    { path: '/BookNew', name: 'BookNew', component: () => import('@/pages/BookNew.vue') },
    { path: '/BookHot', name: 'BookHot', component: () => import('@/pages/BookHot.vue') },
    { path: '/BookStore', name: 'BookStore', component: () => import('@/pages/search/BookStore.vue') },
    { path: '/BookSheet', name: 'BookSheet', component: () => import('@/pages/booklist/BookSheet.vue') },
    { path: '/addBookSheet', name: 'addBookSheet', component: () => import('@/pages/booklist/addBookSheet.vue')},
    { path: '/BookAlbum', name: 'BookAlbum', component: () => import('@/pages/BookAlbum.vue') },
    { path: '/PressDetail', name: 'PressDetail', component: () => import('@/pages/press/PressDetail.vue') },

    { path: '/BookModule/:id', name: 'BookModule', component: () => import('@/pages/BookModule.vue') },
    { path: '/AlbumDetail/:id', name: 'AlbumDetail', component: () => import('@/pages/booklist/AlbumDetail.vue') },
    { path: '/ElectronBookDetail/:id', name: 'ElectronBookDetail', component: () => import('@/pages/detail/ElectronBookDetail.vue') },
    { path: '/SoundBookDetail/:id', name: 'SoundBookDetail', component: () => import('@/pages/detail/SoundBookDetail.vue') },
    { path: '/Help', name: 'Help', component: () => import('@/pages/users/Help.vue') },


    { path: '/UserInfo', name: 'UserInfo', component: () => import('@/pages/users/UserInfo.vue'), meta: { requireAuth: true } },
    { path: '/MyPurchase', name: 'MyPurchase', component: () => import('@/pages/users/MyPurchase.vue'), meta: { requireAuth: true } },
    { path: '/AccountSet', name: 'AccountSet', component: () => import('@/pages/users/AccountSet.vue'), meta: { requireAuth: true } },
    { path: '/History', name: 'History', component: () => import('@/pages/users/History.vue'), meta: { requireAuth: true } },
    { path: '/MyBorrow', name: 'MyBorrow', component: () => import('@/pages/users/MyBorrow.vue'), meta: { requireAuth: true } },
    { path: '/MyFollow', name: 'MyFollow', component: () => import('@/pages/users/MyFollow'), meta: { requireAuth: true } },
    { path: '/MyCollect', name: 'MyCollect', component: () => import('@/pages/users/MyCollect'), meta: { requireAuth: true } },
    { path: '/MyBookList', name: 'MyBookList', component: () => import('@/pages/users/MyBookList'), meta: { requireAuth: true } },
    { path: '/Classics', name: 'Classics', component: () => import('@/pages/Classics') },
    { path: '/Purchase', name: 'Purchase', component: () => import('@/pages/Purchase') },
  ],
scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // 判断该路由是否需要登录权限
  if (to.meta.requireAuth) {
    // 通过vuex state获取当前的token是否存在
    if (common.getToken()) {
      next();
    } else {
      common.showLogin();
    }
  } else {
    next();
  }
})

router.selfaddRoutes = function (params) {
  router.matcher = new router().matcher;
  router.routes(params)
}

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js